import React, { useEffect, useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import StatusComp from "../../components/StatusComp";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  dummyimage,
  edit_icon,
  eye_icon,
  green_icon,
  red_icon,
  user,
  view_icon,
} from "../../assets/imgs";
import { post, get } from "../../Services/ApiHandler";
import { URL as API } from "../../Services/Constant";
import AlreadyComPopup from "../../components/Popup/AlreadyComPopup";

const KnfCompanyAdminGenerate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const type = location?.state?.type;
  const givenpermissions = JSON.parse(
    localStorage.getItem("user_permission") ?? "[]",
  );
  const userData = JSON.parse(localStorage.getItem("company") ?? "{}");
  const [logo, setLogo] = useState();
  const [ownerImg, setOwnerImg] = useState();
  const [companyID, setCompanyID] = useState(location?.state?.data?.id);
  const [email_verified, setEmail_verified] = useState(0);
  const [fullData, setFullDate] = useState({});
  const [popup, setPopup] = useState(false);

  const createdAt = moment().format("DD-MM-YYYY");

  const comDataObj = {
    id: "",
    name: "",
    email: "",
    role_id: "",
    knf_role_id: "",
    mobile: "",
    password: "",
    password_confirmation: "",
  };
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const [comData, setComData] = useState(comDataObj);
  const [admindetails, setAdminDetails] = useState({});

  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);

  const [siteErrors, setSiteErrors] = useState({});
  const [emailCheckData, setEmailCheckData] = useState({});
  const [emailCheckFlag, setEmailCheckFlag] = useState(0);
  const [flagEmail, setFlagEmail] = useState(0);

  const [visible, setVisible] = useState(false);
  const [confVisible, setConfVisible] = useState(false);

  const [siteList, setSiteList] = useState([]);
  const [companyKnfRole, setCompanyKnfRole] = useState([]);
  const [locList, setLoclist] = useState([]);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const [isEmailBeingEdited, setIsEmailBeingEdited] = useState(false);

  const getKfnRole = () => {
    post(API.SUPER_COMPANY_ADMIN_ROLES, {})
      .then((res) => {
        if (res?.status == "success") {
          let arr = res?.lists?.filter((i) => i.company_id == userData?.id);
          console.log("filterArr", arr);
          setCompanyKnfRole(arr);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getLocationList = () => {
    get(API.COMPANY_LOCATION)
      .then((res) => {
        if (res?.status == "success") {
          setLoclist(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getView = () => {
    let data = location?.state?.data;
    setFullDate(data);
    if (data?.email_verified) {
      setEmail_verified(data?.email_verified);
    }

    let ob = {
      id: "",
      name: "",
      email: "",
      role_id: "",
      knf_role_id: "",
      mobile: "",
      password: "",
      password_confirmation: "",
    };

    if (data?.id) {
      ob.id = data?.id;
    }

    if (data?.name) {
      ob.name = data?.name;
    }

    if (data?.email) {
      ob.email = data?.email;
    }
    if (data?.phone) {
      ob.mobile = data?.phone;
    }
    if (data?.knf_role?.id) {
      ob.role_id = data?.knf_role?.id;
    }

    setComData(ob);
    setEmailCheckFlag(1);
  };

  useEffect(() => {
    getKfnRole();
    getLocationList();

    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  const validate = () => {
    const newErrors = {};
    const singaporeMobileRegex = /^[89]\d{7}$/;

    if (comData?.name?.length == 0) newErrors.name = "Name is required";
    if (comData?.role_id?.length == 0) newErrors.role_id = "Select Role";
    if (comData?.mobile?.length == 0) newErrors.mobile = "Mobile is required";
    if (comData?.email?.length == 0 || !emailRegex.test(comData?.email))
      newErrors.email = "Valid Email is required";
    // if (
    //   !comData?.mobile
    //   // || !singaporeMobileRegex.test(comData?.mobile)
    // ) {
    //   newErrors.mobile = "Enter valid 9-digit Singapore number";
    // }
    if (
      !comData?.mobile ||
      (comData?.mobile?.length !== 8 && comData?.mobile?.length !== 10)
    ) {
      newErrors.mobile = "Enter valid 8-digit or 10-digit mobile number";
    }

    if (!companyID) {
      // if (comData?.password?.length == 0 || comData?.password.length < 6)
      //   newErrors.password = "Password must be at least 6 characters";
      // if (comData?.confirmPassword !== comData?.password)
      //   newErrors.confirmPassword = "Passwords do not match";
      // if (!logo) newErrors.logo = "Company Logo is required";
      // if (!ownerImg) newErrors.ownerImg = "Primary Person image is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEmailChange = (even) => {
    const value = even.target.value;

    setFlagEmail(1);

    // Set flag to indicate email is being edited
    if (location?.state?.type === "edit") {
      setIsEmailBeingEdited(true);
    }

    // keep existing change handler
    handleChange(even);

    // clear previous fetched existing-user data
    setCompanyID("");
    setEmailCheckData({});

    // remove old ids so update API won't trigger
    setComData((prev) => ({
      ...prev,
      id: "",
      email: value,
    }));

    if (location?.state?.type == "edit") {
      setEmailCheckFlag(1);
    } else {
      setEmailCheckFlag(0);
    }
  };

  const handleEmailCheck = () => {
    if (location?.state?.type == "edit") {
      if (fullData?.email == comData?.email) {
        toast.error("Same Email Entered");
      } else {
        emailCheck();
        // Reset the flag after checking
        setIsEmailBeingEdited(false);
      }
    } else {
      emailCheck();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // if (comData?.email?.length < 0) {
    //   setEmailCheckData({});
    // }
    setComData((prev) => ({ ...prev, [name]: value }));

    // clear specific error while typing
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = () => {
    if (validate()) {
      const formdata = new FormData();
      formdata.append("company_id", user_details?.company_id);
      formdata.append("name", comData?.name);
      formdata.append("email", comData?.email);
      if (comData?.role_id) {
        formdata.append("knf_role_id", comData?.role_id);
      } else {
        formdata.append("knf_role_id", "");
      }
      formdata.append("phone", comData?.mobile);
      formdata.append("knf_company", 1);
      formdata.append("knf_type", 1);
      // if (location?.state?.type == "edit") {
      if (comData?.id) {
        // if (editID) {
        //   formdata.append("user_id", editID);
        // } else {
        // formdata.append("user_id", location?.state?.data?.id);
        formdata.append("user_id", comData?.id);
        // }
      }
      // if (comData?.password) {
      //   formdata.append("password", comData?.password);
      // }
      // if (comData?.password_confirmation) {
      //   formdata.append(
      //     "password_confirmation",
      //     comData?.password_confirmation
      //   );
      // }

      if (companyID) {
        // formdata.append("_method", "PATCH");
        post(API.ADMIN_EDIT_COMPANY, formdata)
          .then((res) => {
            if (res?.status == "success") {
              toast.success(res?.message);
              navigate("/knf-company-admin-list");
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      } else {
        post(API.ADMIN_ADD_COMPANY, formdata)
          .then((res) => {
            if (res?.status == "success") {
              toast.success(res?.message);
              navigate("/knf-company-admin-list");
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
      //   console.log("Submit successful", comData);
    }
  };

  const handleLogoChange = (event) => {
    let image = event.target.files[0];
    if (image) {
      setLogo(image);
      setErrors((prev) => ({
        ...prev,
        logo: "",
      }));
    }
  };
  // console.log('logo', logo)

  const handlePrimaryImg = (event) => {
    let image = event.target.files[0];
    if (image) {
      setOwnerImg(image);
      setErrors((prev) => ({
        ...prev,
        ownerImg: "",
      }));
    }
  };

  const autoFetchData = (data) => {
    setEmailCheckData(data);
    let ob = {
      id: "",
      name: "",
      email: "",
      role_id: "",
      knf_role_id: "",
      mobile: "",
      password: "",
      password_confirmation: "",
    };

    if (data?.company?.id) {
      setCompanyID(data?.company?.id);
    }

    if (data?.company?.logo) {
      setLogo(data?.company?.logo);
    }

    if (data?.company?.name) {
      ob.companyName = data?.company?.name;
    }

    if (data?.company?.company_code) {
      ob.companyCode = data?.company?.company_code;
    }

    if (data?.user?.id) {
      ob.id = data?.user?.id;
    }

    if (data?.user?.name) {
      ob.name = data?.user?.name;
    }

    if (data?.user?.email) {
      ob.email = data?.user?.email;
    } else {
      ob.email = comData?.email;
    }

    if (data?.user?.phone) {
      ob.mobile = data?.user?.phone;
    }
    if (data?.company?.location) {
      ob.location = data?.company?.location;
    }

    setComData(ob);
    if (data?.user?.profile_image) {
      setOwnerImg(data?.user?.profile_image);
    }
  };

  const emailCheck = () => {
    let formdata = new FormData();
    if (comData?.email?.length > 0) {
      formdata.append("email", comData?.email);
      post("user/" + API.EMAIL_CHECK, formdata)
        .then((res) => {
          setFlagEmail(0);
          if (res?.exists && location?.state?.type == "edit") {
            toast.error(res?.message);
            setEmailCheckFlag(0);
            let data = res?.userData?.[0];
            let emCheck = {
              ...data?.user,
              company: data?.company,
            };
            setAdminDetails(emCheck);
            if (emCheck?.id) {
              setPopup(true);
            } else {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
            // } else if (res?.exists && res?.message?.includes("admin")) {
          } else if (
            res?.exists &&
            res?.message == "This email is already an admin."
          ) {
            toast.error(res?.message);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
            setEmailCheckFlag(1);
            if (res?.userData?.length > 0) {
              let data = res?.userData?.[0];
              if (data?.user?.knf_type == 1) {
                autoFetchData(data);
              } else if (data?.user?.knf_type == null) {
                autoFetchData(data);
              } else {
                toast.error("Email ID already exists");
              }
            } else {
              let ob = {
                ...(location?.state?.type == "edit" ? comData : comDataObj),
                email: comData.email,
              };
              setComData(ob);
              setEmailCheckData({});
              if (location?.state?.type !== "edit") {
                toast("please enter all required fields");
              }
            }
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Please Enter Valid Email");
    }
  };

  const handleClosePopup = () => {
    setPopup(false);
    window.location.reload();
  };

  return (
    <div className="dashRightView">
      <StatusComp name={"Admin"} type={type} />

      {popup && (
        <AlreadyComPopup
          setPopup={setPopup}
          admindetails={admindetails}
          locList={locList}
        />
      )}

      <div className="d-flex flex-wrap gap-5">
        <div className="col-md-5">
          <div className="d-flex w-100 ac-jb">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Email ID<span className="text-danger">*</span>
            </p>
            {type == "edit" && (
              <p className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-12 mb-1 text-primary mx-2">
                {email_verified
                  ? "Email Verified"
                  : "Email Verification pending"}
              </p>
            )}
          </div>
          <div className="d-flex">
            <input
              className="input-box"
              name="email"
              value={comData?.email}
              onChange={handleEmailChange}
              type="email"
              placeholder="Email ID"
              disabled={type == "view" ? true : false}
            />
            {/* {email_verified == 0 && ( */}
            {/* {comData?.email?.length > 1 && ( */}
            {type != "view" && (
              <button
                className={`email_check_btn ${
                  !emailRegex?.test(comData?.email) ? "opacity-50" : ""
                }`}
                disabled={
                  comData?.email?.length == 0
                    ? true
                    : type == "view"
                      ? true
                      : false
                }
                onClick={handleEmailCheck}
              >
                Check
              </button>
            )}
            {/* )} */}
          </div>
          {errors.email && <p className="err">{errors.email}</p>}
        </div>
        {/* {emailCheckFlag == 1 && (  )} */}
        <>
          {emailCheckFlag == 1 && (
            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                Name<span className="text-danger">*</span>
              </p>
              <input
                className="input-box"
                name="name"
                value={comData?.name}
                onChange={handleChange}
                type="text"
                placeholder="Name"
                disabled={
                  type == "view"
                    ? true
                    : emailCheckData?.company?.name
                      ? true
                      : emailCheckFlag == 0
                        ? true
                        : false ||
                          (location?.state?.type === "edit" &&
                            isEmailBeingEdited)
                }
              />
              {errors?.name && <p className="err">{errors?.name}</p>}
            </div>
          )}
          {emailCheckFlag == 1 && (
            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary flex">
                Primary Singapore Mobile number
                <span className="text-danger">*</span>
              </p>
              <input
                name="mobile"
                value={comData?.mobile}
                maxLength={8}
                onChange={(e) => {
                  let val = e.target.value;
                  if (!/^\d*$/.test(val)) {
                    return;
                  }
                  handleChange(e);
                }}
                className="input-box"
                type="text"
                placeholder="+65 Mobile number"
                disabled={
                  type == "view"
                    ? true
                    : emailCheckData?.phone
                      ? true
                      : emailCheckFlag == 0
                        ? true
                        : false ||
                          (location?.state?.type === "edit" &&
                            isEmailBeingEdited)
                }
              />
              {errors.mobile && <p className="err">{errors.mobile}</p>}
            </div>
          )}
          {user_details?.email == location?.state?.data?.email ? (
            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                Role<span className="text-danger">*</span>
              </p>
              <input
                className="input-box"
                name="role_id"
                value={location?.state?.data?.knf_role?.name}
                type="text"
                placeholder="Role"
                disabled
              />
            </div>
          ) : (
            <>
              {emailCheckFlag == 1 && (
                <div className="col-md-5">
                  <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary flex">
                    Role<span className="text-danger">*</span>
                  </p>
                  <select
                    name="role_id"
                    value={comData?.role_id}
                    onChange={handleChange}
                    className="input-box"
                    type="text"
                    disabled={
                      type == "view"
                        ? true
                        : emailCheckData?.role_id
                          ? true
                          : emailCheckFlag == 0
                            ? true
                            : false ||
                              (location?.state?.type === "edit" &&
                                isEmailBeingEdited)
                    }
                  >
                    <option>Select Role</option>
                    {companyKnfRole
                      ?.filter((it) => it?.created_by)
                      ?.map((item) => {
                        return (
                          <option value={item?.id} key={item?.id}>
                            {item?.name}
                          </option>
                        );
                      })}
                  </select>
                  {errors.role_id && <p className="err">{errors.role_id}</p>}
                </div>
              )}
            </>
          )}
        </>
      </div>
      <div className="d-flex ac-jb mt-5">
        <button
          onClick={() => navigate(-1)}
          className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
        >
          Back
        </button>

        {givenpermissions?.includes("CAN-Edit-KNF_COMPANY_ADMIN") &&
          type != "view" &&
          flagEmail == 0 && (
            <>
              {emailCheckData?.id ? (
                <button
                  onClick={handleSubmit}
                  className={` submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 ${
                    emailCheckData?.email == comData?.email ? "" : "opacity-50"
                  }`}
                  disabled={
                    emailCheckData?.email == comData?.email ? false : true
                  }
                >
                  {type == "edit" ? "Submit" : "Add"}
                </button>
              ) : (
                <button
                  onClick={handleSubmit}
                  className={`submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 ${
                    emailCheckFlag == 1 ? "" : "opacity-50"
                  }`}
                  disabled={emailCheckFlag == 1 ? false : true}
                >
                  {type == "edit" ? "Submit" : "Add"}
                </button>
              )}
            </>
          )}
      </div>
    </div>
  );
};

export default KnfCompanyAdminGenerate;
